import { render, staticRenderFns } from "./guanlianche.vue?vue&type=template&id=013af6e4&scoped=true&"
import script from "./guanlianche.vue?vue&type=script&lang=js&"
export * from "./guanlianche.vue?vue&type=script&lang=js&"
import style0 from "./guanlianche.vue?vue&type=style&index=0&id=013af6e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013af6e4",
  null
  
)

export default component.exports